<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oVvyy7/tc-custom/9781507202548.jpg?1730542028261" alt="This image is the cover for the book Power of Positive Energy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Power of Positive Energy
      </h1>
      <p class="bookDescription body article font2">
        <b>From the founder of ForeverConscious.com comes a guide to cultivating positive feelings and projecting positive energy.</b><br/><br/>Positive energy creates positive outcomes. But how do you get the good vibes going? It all comes down to understanding and embracing the innate and energetic power of your soul.<br/><br/>With the guidance of Tanaaz Chubb, creator of ForeverConscious.com, you will begin a journey that will give rise to an understanding of your soul’s energy and its connection to the Universal energy all around us. You will free yourself from negativity, fears, and the parts of your life that are no longer serving you. You will tune into the powerful vibrations that allow you to live your life to the fullest potential. Tanaaz shares the secrets to awakening positivity through introspective and inspiring meditations, writing prompts, and exercises including:<br/> -Ten-Minute Soul Connection Meditation<br/> -Switching a Negative Thought for a Positive One<br/> -Identifying Your Self-Limiting Beliefs<br/> -A Positive Energy Cleanse<br/> -Releasing the Past<br/><br/>It’s time to tune into the positive vibrations that exist within you, and around you. You can rise above negative influences, reclaim your power, and manifest a life that is easy, joyous, and inspired!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tanaaz Chubb
      </h2>
      
      <p class="authorDescription body article">Tanaaz Chubb&#160;is the cocreator and owner of&#160;<I>Forever Conscious</I>, a website dedicated to spiritual well-being, mindfulness, and healing. She is the author of&#160;<I>Becoming Forever Conscious</I>,&#160;<I>Messages for the Soul</I>, and&#160;<I>The Power of Positive Energy</I>, has been featured in&#160;<I>Elle Magazine Italia</I>, and is a contributing writer for&#160;<I>HuffPost</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abcf58ac